import React, {Component} from 'react'
import {Helmet} from 'react-helmet'
import MusicAlgoNav from '../MusicAlgoNav'
import MusicAlgoFooter from '../MusicAlgoFooter'
import {Grid, Row, Jumbotron} from 'react-bootstrap'
import SectionBlock from '../SectionBlock'
import VideoComponent from '../VideoComponent'
import AlgoText from '../AlgoText'
import './AlgoPage.css'

class AlgoPage extends Component {
    constructor(props) {
        /*
        this.props contains a json object of video sources VidSrcMap,
        image to show,
        content to show below video textMap
        
        this.state has one attribute, text which reflects what type of video is viewed
        
        */
        super(props);
        this.clickHandler = this.clickHandler.bind(this)
        this.state = {txt: ""}
    }

    clickHandler(t) {
        console.log('state change', t)
        this.setState({txt: t})
    }
    render(){
        let imgSrc = this.props.textMap['img'];
       return (
            <div>
                <Helmet>
                    <title>{this.props.title} | MusicAlgo</title>
                    <meta name="description" content={"Intuitive explanations, visual demonstrations, and musical mnemonics for learning " + this.props.title} />
                </Helmet>
                <div className="cont">
                <Jumbotron style={{marginBottom:"0"}}>
                    <h1 className="titleHeader">{this.props.title}</h1>
                    {imgSrc}
                </Jumbotron>
                <Grid>
                    <Row>
                        <SectionBlock 
                            handler={this.clickHandler} 
                            id="intuition" />
                        <SectionBlock 
                            handler={this.clickHandler} 
                            id="analysis" />
                        <SectionBlock 
                            handler={this.clickHandler} 
                            id="songAndCode" />
                    </Row>
                    <VideoComponent 
                        txt={this.state.txt}
                        vidSrc={this.props.textMap['videos'][this.state.txt]||''}
                        >
                    </VideoComponent>
               </Grid>
                <AlgoText algoType={this.state.txt} textMap={this.props.textMap} />
                </div>
            </div>
        )
    }
}
export default AlgoPage



// WEBPACK FOOTER //
// ./src/AlgoPage/AlgoPage.js